export default __webpack_public_path__ + "static/fv-nr-1-6d6ebcb150f9b39cea2682c9a21de66d.png";